/**
 * Склейка классов без сторонних пакетов — clsx на один вызов не тянем
 * («тяжёлые UI-киты не тянем», см. CLAUDE.md).
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
